var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel panel-default",style:({
    'margin-bottom': _vm.marginBottom,
}),attrs:{"id":_vm.id}},[(_vm.title)?_c('div',{staticClass:"panel-heading"},[_c('h4',[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_vm._t("default")],2),_vm._v(" "),(_vm.$slots.footer)?_c('div',{staticClass:"panel-footer"},[_vm._t("footer")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }